import React from "react";
import { createRoot } from "react-dom/client";

import Page1 from './Pages/Page1';
import './Pages/final.css'

createRoot(document.getElementById("root")).render(<Page1  />);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
